// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import PdiPin from '@deere/cps-it.warranty-model-factory/lib/pdi-pin';
import {fixCursorPosition} from '../../../../../shared/services/fix-cursor-position';
import {formatPin} from '../../../../../shared/services/format-pin';

function handlePinChange(index, event) {

    const formattedPin = formatPin(event.target.value);

    this.actions.updateMassChannelPdiPin(index, formattedPin);
    fixCursorPosition(event, formattedPin);

}

const FailurePanelContainer = props =>
    <div className='failure-panel'>
        <h3>
            <FormattedMessage id='PINS'/>
        </h3>
        <div className='pin-collection'>
            {
                props.pins.map((item, index) =>
                    <EditableField
                        isEditable={props.isEditable}
                        key={index}
                        value={item.pin}
                    >
                        <div>
                            <input
                                maxLength={18}
                                onChange={handlePinChange.bind(props, index)}
                                value={item.pin}
                            />
                        </div>
                    </EditableField>
                )
            }
        </div>
    </div>;

FailurePanelContainer.displayName = 'FailurePanelContainer';
FailurePanelContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    formValidation: PropTypes.object.isRequired,
    isDuplicateClaim: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    isValidClaim: PropTypes.bool.isRequired,
    pins: PropTypes.arrayOf(PropTypes.instanceOf(PdiPin)).isRequired
};

export default FailurePanelContainer;



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/components/failure-panel/failure-panel-container.js